import { useNavigate } from 'react-router'

import { useSession } from '@/contexts/auth/session'
import { setAuthTokens } from '@/contexts/auth/token-storage'
import { type AuthTokens } from '@/services/fintalk/services/fintalk-backoffice/auth/types'

// Após o login, volta para `redirect` quando for um caminho interno seguro
// (ex.: o fluxo OAuth do /connect). Senão, vai para /companies.
const resolvePostLoginPath = (): string => {
  const redirect = new URLSearchParams(window.location.search).get('redirect')
  return redirect && redirect.startsWith('/') && !redirect.startsWith('//')
    ? redirect
    : '/companies'
}

export const useAuthSession = () => {
  const { authenticateSession } = useSession()

  const navigate = useNavigate()

  const enterSession = async (tokens: AuthTokens) => {
    setAuthTokens(tokens)

    authenticateSession()

    await navigate(resolvePostLoginPath())
  }

  return { enterSession }
}
